var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8223 0.00146484C17.2028 0.00167437 18.3223 1.12088 18.3223 2.50146V17.5015C18.322 18.8818 17.2026 20.0013 15.8223 20.0015H5.82227C4.44171 20.0015 3.32252 18.882 3.32227 17.5015V2.50146C3.32227 1.12075 4.44155 0.00146484 5.82227 0.00146484H15.8223ZM10.8223 15.0015C7.54342 15.0015 5.64034 16.0331 4.57227 17.1948V17.5015C4.57252 18.1916 5.13207 18.7515 5.82227 18.7515H15.8223C16.5123 18.7513 17.072 18.1915 17.0723 17.5015V17.1948C16.0043 16.033 14.1012 15.0015 10.8223 15.0015ZM10.8223 6.25146C8.7512 6.25146 7.07227 7.9304 7.07227 10.0015C7.07252 12.0723 8.75135 13.7515 10.8223 13.7515C12.893 13.7513 14.572 12.0722 14.5723 10.0015C14.5723 7.93053 12.8932 6.25167 10.8223 6.25146ZM8.94727 2.50146C8.60209 2.50146 8.32227 2.78129 8.32227 3.12646C8.32252 3.47143 8.60224 3.75146 8.94727 3.75146H12.6973C13.0421 3.75126 13.322 3.4713 13.3223 3.12646C13.3223 2.78142 13.0423 2.50167 12.6973 2.50146H8.94727Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.348839a5bf4532227b5796cd8d068faf.svg";
export { ForwardRef as ReactComponent };